export const OVERVIEW_ROUTES: Record<string, string> = {
  '/': '/workbench/overview',
  '/workbench': '/workbench/overview',
  '/funds': '/funds/overview',
  '/investment': '/investment/overview',
  '/portfolio': '/portfolio/overview',
  // 投后与退出共用一个概览页：退出管理的分组入口也指向同一地址。
  '/portfolio/exit': '/portfolio/overview',
  '/research': '/research/overview',
  '/analysis': '/analysis/overview',
};
export const OVERVIEW_ALIASES: Record<string, string> = {
  '/home': '/',
  '/overview': '/analysis',
  '/portfolio/home': '/portfolio',
  '/research/home': '/research',
  '/research/workbench': '/research',
  '/portfolio/exit/home': '/portfolio/exit',
};
type NavigationItem = {
  path?: string;
  hideInMenu?: boolean;
  unaccessible?: boolean;
  children?: NavigationItem[];
};
export function overviewGroup(path?: string): boolean {
  return !!path && !!OVERVIEW_ROUTES[path];
}

/** 没有独立概览页、与共享概览共用同一地址的分组。 */
const SHARED_OVERVIEW_GROUPS = new Set(['/portfolio/exit']);
export function menuTarget(item: NavigationItem): string | undefined {
  if (item.unaccessible || item.hideInMenu) return undefined;
  if (!item.children) return item.path;
  const overview = OVERVIEW_ROUTES[item.path ?? ''];
  // 分组概览即使被 hideInMenu 隐藏（例如退出管理的概览子项），
  // 仍应作为分组标题的默认入口；仅当该概览不可访问时才回退到首个可见子项。
  if (overview) {
    const overviewChild = item.children.find(
      (child) => child.path === overview && !child.unaccessible,
    );
    if (overviewChild) return overview;
    // 分组没有自己的概览页，与别的分组共用共享概览时，标题仍进入该共享页。
    if (SHARED_OVERVIEW_GROUPS.has(item.path ?? '')) return overview;
  }
  const children = item.children.filter(
    (child) => !child.hideInMenu && !child.unaccessible,
  );
  const leaves = (nodes: NavigationItem[]): string[] =>
    nodes.flatMap((node) => {
      const target = menuTarget(node);
      return target ? [target] : [];
    });
  const targets = leaves(children);
  return overview && targets.includes(overview) ? overview : targets[0];
}
